// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3o9gN","list":"BalanceDue_list__GVnD_","listRow":"BalanceDue_listRow__198vc","total":"BalanceDue_total__1gBXM"};